import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import { TechnicalSheetDataProvider } from "@/pages/management/technicalsheets/technicalsheet/TechnicalSheetContextProvider.tsx";
import { TechnicalSheetListDataProvider } from "@/pages/management/technicalsheets/list/TechnicalSheetListContextProvider.tsx";
import { prdOrderRoutes } from "@/pages/management/prdorder/routes.tsx";

const TechnicalSheetGroupsPage = lazy(
  () =>
    import(
      "@/pages/management/technicalsheet-groups/TechnicalSheetGroupsPage.tsx"
    ),
);

const TechnicalSheetsPage = lazy(
  () => import("./technicalsheets/TechnicalSheetsPage"),
);
const TechnicalSheetsList = lazy(
  () => import("./technicalsheets/list/TechnicalSheetsList"),
);
const TechnicalSheetPage = lazy(
  () => import("./technicalsheets/technicalsheet/TechnicalSheetPage"),
);

export const managementRoutes: RouteObject[] = [
  // Achats / Commande de produits ---------------------------------------------
  ...prdOrderRoutes,

  // Gestion / Groupes de fiches techniques ------------------------------------
  {
    path: "/management/technicalsheetgroups/:domainId?",
    element: <TechnicalSheetGroupsPage />,
  },

  // Gestion / Fiches techniques -----------------------------------------------
  {
    path: "/management/technicalsheets/",
    element: <TechnicalSheetsPage />,
    children: [
      {
        path: ":domainId",
        children: [
          {
            path: "",
            element: (
              <TechnicalSheetListDataProvider>
                <TechnicalSheetsList />
              </TechnicalSheetListDataProvider>
            ),
          },
          {
            path: ":technicalSheetId",
            element: (
              <TechnicalSheetDataProvider>
                <TechnicalSheetPage />
              </TechnicalSheetDataProvider>
            ),
          },
        ],
      },
    ],
  },
];
